import React, { Fragment } from "react"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { userLogout } from "utils"
import { updateUserAccountInfo } from "@redux"
import { Button, Select } from "components"
import classes from "./FssCashierBranches.module.scss"

const FssCashierBranches = (props) => {
  const {
    setContent,
    selectedBranch,
    setSelectedBranch
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const { _id: accountId, cashierBranches, fullName } =
    useSelector(state => state.userAccountInfo)

  const handleLogout = () => {
    userLogout()

    history.push("/")
  }

  const saveCashierBranch = () => {
    const json =
      localStorage.getItem("defaultCashiersBranch") || "{}"

    const defaultCashiersBranch =
      JSON.parse(json)

    defaultCashiersBranch[accountId] = selectedBranch

    localStorage.setItem(
      "defaultCashiersBranch",
      JSON.stringify(defaultCashiersBranch)
    )

    const selectedCashierBranch =
      cashierBranches.find(cb =>
        cb._id === selectedBranch.value
      )

    dispatch(
      updateUserAccountInfo({
        branchName: selectedBranch.label,
        branchId: selectedBranch.value,
        selectedCashierBranch
      })
    )
  }

  const handleSelectBranch = () => {
    if (!selectedBranch) return

    saveCashierBranch()

    setContent("startShift")
  }

  const branchOptions =
    cashierBranches.map(c => ({
      label: c.name,
      value: c.branchId
    }))

  const isLtr = i18n.dir(i18n.language)  === "ltr"

  return (
    <Fragment>
      <div className={classes["title"]}>
        {t("ابتدا_شعبه_خود_را_انتخاب_کنید")}
      </div>

      <Select
        isSearchable={false}
        className={classes["select"]}
        showSearchInput={false}
        options={branchOptions}
        placeholder={t("شعبه_های_کاربر")}
        onChange={(select) => setSelectedBranch(select)}
        value={selectedBranch}
      />

      <div className={classes["footer"]}>
        <Button
          color="success"
          onClick={handleSelectBranch}
        >
          {t("انتخاب")}
        </Button>

        <Button
          color="danger"
          className={clsx(classes["button"], isLtr && classes["button-ltr"])}
          onClick={handleLogout}
        >
          {t("خروج")}
        </Button>
      </div>

      <div className={classes["fullname"]}>
        {fullName}
      </div>
    </Fragment>
  )
}

export default FssCashierBranches